export default "__VITE_ASSET__D8oKhhWz__"